module.exports = "pegasus_template/assets/themelp1/health/104.png";